var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.list),function(item){return _c('div',{key:item.index,staticClass:"item",on:{"click":function($event){return _vm.goDetail(item.index)}}},[_c('div',{staticClass:"item_title"},[_vm._v(_vm._s(item.title))]),_c('img',{staticClass:"item_right",attrs:{"src":require("@/assets/icon/icon-right.svg")}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }